"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Typography = require("../../components/Typography");
var _default = exports.default = {
  Disclaimer: _styledComponents.default.span`
    position: relative;
  `,
  Trigger: _styledComponents.default.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
  `,
  CloseButton: _styledComponents.default.button`
    position: absolute;
    top: 10px;
    right: 10px;
    background: transparent;
    border: none;
    width: 15px;
    padding: 0;
    cursor: pointer;
  `,
  DisclaimerBody: _styledComponents.default.div`
    && .simplebar-scrollbar:before {
      background: #333;
      opacity: 1;
    }
    a {
      color: inherit;
    }
  `,
  GradientDisclaimerBodyDown: _styledComponents.default.div``,
  GradientDisclaimerBodyUp: _styledComponents.default.div``,
  DisclaimerScroll: _styledComponents.default.div``,
  DisclaimerBodyContent: (0, _Typography.StyledType)("div", {
    family: "nobel-book",
    size: "bodyCopy1"
  })`
    p {
      font-size: inherit;
      font-family: inherit;
    }
  `
};